/**
 * @fileoverview Action type constants for deals landing page Redux module
 *
 * Uses namespaced action types with 'dealsLanding/' prefix to avoid conflicts
 * with other Redux modules. Follows the pattern: MODULE_NAME/ACTION_NAME
 */

// Async operation action types for deal type changes
export const SET_DEAL_TYPE_REQUEST = 'dealsLanding/SET_DEAL_TYPE_REQUEST';
export const SET_DEAL_TYPE_SUCCESS = 'dealsLanding/SET_DEAL_TYPE_SUCCESS';
export const SET_DEAL_TYPE_FAILURE = 'dealsLanding/SET_DEAL_TYPE_FAILURE';

// Filter update action types
export const SET_DEAL_TYPE_FILTER = 'dealsLanding/SET_DEAL_TYPE_FILTER';
export const SET_LOCATION_FILTER = 'dealsLanding/SET_LOCATION_FILTER';
export const SET_CATEGORY_CODE_FILTER = 'dealsLanding/SET_CATEGORY_CODE_FILTER';

// Data management action types
export const SET_CATEGORIES = 'dealsLanding/SET_CATEGORIES';
export const UPDATE_CATEGORY_VENDOR_COUNTS =
	'dealsLanding/UPDATE_CATEGORY_VENDOR_COUNTS';

export const DEALS_LANDING_PAGE_FETCHED =
	'dealsLanding/DEALS_LANDING_PAGE_FETCHED';
export const DEAL_LOADED = 'dealsLanding/DEAL_LOADED';
export const SET_DEALS_PAGE_STATE = 'dealsLanding/SET_DEALS_PAGE_STATE';
